import classNames from 'classnames';
import { useLocalization } from '../../../context/Localization/localization';
import css from './UpsellButton.module.scss';
import { BaseButtonBase } from '../BaseButtonBase/BaseButtonBase';
import { UpsellButtonProps } from './UpsellButton.types';
import { ReactNode } from 'react';
import { GMSizedIcon } from '../../Icon';

/**
 * The upsell button that adds the upsell to the cart.
 *
 * @param label - {@link GenericButtonProps.label label} description.
 * @param styleType - {@link GenericButtonProps.styleType styleType} description.
 * @param price - {@link GenericButtonProps.price price} description.
 * @param title - {@link GenericButtonProps.title title} description.
 * @param className - {@link GenericButtonProps.className className} description.
 * @param onClick - {@link GenericButtonProps.onClick onClick} description.
 * @param add - {@link GenericButtonProps.add add} description.
 * @param id - {@link GenericButtonProps.id id} description.
 * @param ariaLabel - {@link GenericButtonProps.ariaLabel ariaLabel} description.
 * @param type - {@link GenericButtonProps.type type} description.
 */
const UpsellButton = ({
    label,
    title,
    styleType,
    price,
    add,
    type,
    onClick,
    className,
    id,
    ariaLabel,
}: UpsellButtonProps): ReactNode => {
    const Localization = useLocalization();

    return (
        <BaseButtonBase
            key={'upsellButton' + label + styleType}
            onClick={onClick}
            type={type}
            title={title}
            classes={{
                root:
                    classNames(className, css.upsellButton, css[styleType]),
            }}
            id={id}
            ariaLabel={ariaLabel}
        >
            <div className={css.labelWrapper}>
                {add ? (
                    <GMSizedIcon
                        iconType={'Add'}
                        iconSize={'custom'}
                        title={Localization.ClickToAddService}
                        ariaLabel={Localization.AddServiceIcon}
                    />
                ) : (
                    <GMSizedIcon
                        iconType={'Close'}
                        iconSize={'custom'}
                        title={Localization.ClickToRemoveService}
                        ariaLabel={Localization.DeleteIcon}
                    />
                )}
                <div className={css.label}>{label}</div>
            </div>
            {!!price && <div className={css.price}>{price}</div>}
        </BaseButtonBase>
    );
};
export default UpsellButton;